import { mapMutations, mapState } from "vuex";
import ComponentsAdding from "./components-adding";

export default {
    mixins: [ComponentsAdding],
    computed: {
        ...mapState("components", ["properties", "legacyElementState"])
    },
    methods: {
        ...mapMutations("components", ["setCurrentInterfaceModel", "setData", "addComponent", "emptyBody", "updateLegacyElementState"]),
        addRawComponent(guid, rawData) {
            const element = { guid };
            this.addComponent({ element, properties: rawData, to: rawData.parent });
        },
        __initStateFromData(data = {}, path = []) {
            Object.entries(data || {}).forEach(([key, value]) => {
                if (key === "_id_" || key === "__ns") { return; }

                const localPath = [...path, key];
                const elementPath = localPath.join(",");

                if (!this.legacyElementState.hasOwnProperty(elementPath)) {
                    const keys = Object.keys(this.legacyElementState);
                    if (!keys.some(entry => entry.endsWith(elementPath))) {
                        const properties = this.properties[key];
                        const { display, readOnly, mandatory } = properties.__generics;

                        this.updateLegacyElementState({
                            guid: elementPath,
                            values: {
                                display, readOnly, mandatory, mandatoryShow: false
                            }
                        });
                    }
                }

                if (value.constructor === Array) {
                    value.forEach((entry, idx) => {
                        this.__initStateFromData(entry, [...localPath, idx]);
                    });
                }
            });
        },
        __loadInterfaceFromJSON(json) {
            if (!json) { return; }

            const { body, components } = json;
            const addBody = srcBody => {
                srcBody.forEach(bodyEntry => {
                    const properties = components[bodyEntry.guid];
                    if (properties) {
                        const data = {
                            type: properties.__component, guid: bodyEntry.guid, to: properties.parent, properties
                        };

                        this.__createComponent(data, false);
                        addBody(bodyEntry.body || []);
                    }
                });
            };

            this.emptyBody();
            if (body) {
                addBody(body);
            } else {
                const skip = [];
                Object.entries(components).forEach(([key, value]) => {
                    if (value.parent && !skip.includes(value.parent)) {
                        skip.push(key);
                        this.addRawComponent(value.parent, components[value.parent]);
                    }

                    this.addRawComponent(key, value);
                    skip.push(key);
                });
            }
            this.setCurrentInterfaceModel(this.properties);
            this.$root.$emit("ui-render-interface");
        }
    }
};
